import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";

@Component({
    selector: "app-team",
    templateUrl: "./team.component.html",
    styleUrls: ["./team.component.scss"],
})
export class TeamComponent implements OnInit {
    prospectus: string[] = [
        "প্রতিষ্ঠাকাল",
        "অবস্থান",
        "লক্ষ্য-উদ্দেশ্য",
        "প্রতিষ্ঠানের পাঠ্যক্রম",
        "সহ-পাঠ্যক্রম কার্যাবলী",
        "শ্রেণি-বিন্যাস",
        "শাখা প্রতিষ্ঠান ও বিভাগসমূহ",
        "তা‘মীরুল মিল্লাত কামিল মাদ্রাসা, বালিকা শাখা",
        "তা‘মীরুল মিল্লাত জামে মসজিদ",
        "তা‘মীরুল মিল্লাত হিফজ বিভাগ",
        "তা‘মীরুল মিল্লাত ছাত্রাবাস ও ছাত্রীনিবাস",
        "আবাসন প্রক্রিয়া",
        "আবাসন চার্জ",
        "গ্রন্থাগার",
        "বিজ্ঞানাগার",
        "কম্পিউটার ল্যাব",
        "তাখাস্সুস বিভাগ",
        "ক্বিরাআত বিভাগ",
        "ছাত্র কল্যাণ বিভাগ",
        "সাহিত্য-সংস্কৃতি বিভাগ",
        "প্রকাশনা বিভাগ",
        "এক নজরে মাদ্রাসার কিছু তথ্য",
        "পরীক্ষা ও মূল্যায়ণ পদ্ধতি",
        "ভর্তি সংক্রান্ত তথ্য",
        "ভর্তি পরীক্ষা",
        "ভর্তি প্রক্রিয়া",
        "২০২৩ শিক্ষাবর্ষে ভর্তি ফি ও বেতন কাঠামো",
    ];

    selectedItem: string = "";

    constructor(private route: ActivatedRoute, private location: Location) {}

    ngOnInit() {
        this.route.paramMap.subscribe((params: ParamMap) => {
            const item = params.get("item");
            if (item && this.prospectus.includes(item)) {
                this.selectedItem = item;
            } else {
                this.selectedItem = this.prospectus[0];
                this.location.replaceState(`/prospectus/${this.selectedItem}`);
            }
        });
    }

    selectItem(item: string) {
        this.selectedItem = item;
        this.location.go(`/prospectus/${item}`);
    }
}
